/** メール本文の定型フッター・引用の折り畳み（改善 A）
 *
 * メール取込のチケットは本文の大半が Google グループの配信フッター・署名・引用で
 * 占有され、顧客が実際に書いた文章が読めない。既定では本文だけを表示し、
 * 定型部分はトグルの裏に畳む。**情報は削除しない**（開けば従来どおり全文が読める）。
 */

/** 折り畳み開始位置の検出パターン。最初にマッチした位置を採用する。 */
const FOOTER_PATTERNS: RegExp[] = [
  /^--\s*$/m, // 署名区切り（RFC 3676）
  /^[-=_]{10,}\s*$/m, // 自社メールの署名罫線（----------------------------------------）
  /^※本メールにそのままご返信いただけます/m,
  /^▼ 対応状況の確認はこちら:/m,
  /^このメールは Google グループのグループ/m,
];

/** 引用行（先頭 >）が 2 行以上連続する最初の位置。無ければ -1。 */
function quoteBlockIndex(text: string): number {
  const lines = text.split("\n");
  let offset = 0;
  for (let i = 0; i < lines.length - 1; i++) {
    const isQuote = /^\s*>/.test(lines[i]);
    const nextIsQuote = /^\s*>/.test(lines[i + 1]);
    if (isQuote && nextIsQuote) return offset;
    offset += lines[i].length + 1;
  }
  return -1;
}

export type SplitBody = {
  visible: string;
  folded: string;
  /** 折り畳んだ行数（トグルのラベルに出す） */
  foldedLines: number;
};

export function splitMessageBody(text: string): SplitBody {
  const body = text || "";
  const hits = [
    ...FOOTER_PATTERNS.map((re) => body.search(re)),
    quoteBlockIndex(body),
  ].filter((i) => i >= 0);
  if (!hits.length) return { visible: body, folded: "", foldedLines: 0 };

  const cut = Math.min(...hits);
  const visible = body.slice(0, cut).replace(/\s+$/, "");
  const folded = body.slice(cut);
  // 本文が丸ごと定型扱いになるケース（先頭からフッター）は畳まない
  if (!visible.trim()) return { visible: body, folded: "", foldedLines: 0 };
  if (!folded.trim()) return { visible: body, folded: "", foldedLines: 0 };

  return { visible, folded, foldedLines: folded.split("\n").length };
}
